module.exports = __webpack_public_path__ + "img/pumpcharge-logo-white.90b577b9.png";